<template>
  <div class="data-view" :style="{ backgroundImage: 'url(' + Bg + ')' }">
    <div class="dv-full-screen-container">
      <topHeader title="资本市场信息披露全景"></topHeader>
      <div class="main-content">
        <v-row style="width: 100%">
          <v-col lg="4" md="12">
            <infodisc id="vegaView1" ref="myvegaView1" style="height: 300px"></infodisc>
          </v-col>
          <v-col lg="4" md="12">
            <auditstatus id="vegaView4" ref="myvegaView4" style="height: 300px"></auditstatus>
          </v-col>
          <v-col lg="4" md="12">
            <infodisceat id="vegaView2" ref="myvegaView2" style="height: 300px"></infodisceat>
          </v-col>
        </v-row>



        <v-row style="width: 100%">

          <v-col lg="4" md="12">
            <intelCenter id="vegaViewintelCenter" ref="myvegaViewintelCenter" style="height: 500px"></intelCenter>
          </v-col>
         

          <v-col lg="8" md="12">
            <annt id="vegaView3" ref="myvegaView3" style="height: 500px"></annt>
          </v-col>

        </v-row>

        <v-row style="width: 100%">
         
          <v-col lg="4" md="12">
            <ESG id="vegaViewesg" ref="myvegaViewesg" style="height: 300px"></ESG>
          </v-col>
          <v-col lg="4" md="12">
            <performance id="vegaViewperformance" ref="myvegaViewperformance" style="height: 300px"></performance>
          </v-col>
          <v-col lg="4" md="12">
            <HeighTransfer id="vegaViewHeighTransfer" ref="myvegaViewHeighTransfer" style="height: 300px"></HeighTransfer>
          </v-col>
        </v-row>
        <!-- <div id="vegaView1"></div> -->


      </div>
    </div>
    <!-- <stdFixed></stdFixed> -->
  </div>
</template>

<script>
 import topHeader from "./components/topHeader.vue";

import Bg from "@/assets/img/bigScreen/bg.png";
import * as vega from "vega";
// import infodisc from "./infodisc.json"
import annt from "./components/annt.vue";
import infodisceat from "./components/infodisceat.vue";
import infodisc from "./components/infodisc.vue";
import apiAxios from "@/config/apiAxios";
import auditstatus from "./components/auditstatus.vue";
import ESG from "./components/ESG.vue";
import performance from "./components/performance.vue";
import HeighTransfer from "./components/HighTransfer.vue"
import intelCenter from "./components/intelCenter.vue";
export default {
  name: "bigScreen",
  components: {
     topHeader,
      annt, infodisceat, infodisc, auditstatus,
    ESG, performance, HeighTransfer, intelCenter
  },

  data() {
    return {
      Bg: Bg,
      // vegaConfig:infodisc,
      annt: annt,
    };
  },
  methods: {
    vegaInit() {
      let params = {
        limit: 10000,
        // filter:
        //   "('F001D' ge '2023-01-01 00:01:01' and matchesPattern('GE8000088E', '.*2022.*')   and ( (matchesPattern( 'GE8000094E', 'N001001.*') and matchesPattern('GE8000088E', '.*定期报告.*'))  or  matchesPattern( 'GE8000094E', '010301.*')) )",
        filter: "(('F001D' eq '2023-06-30T00:00:00') and ('ISVALID' eq 1))"
      };

      apiAxios.apmASyncPost("ld_info_disc", params,  (_res) => {
        if (_res.code == 200) {
          this.getApmTask(_res.data.taskId, "updateVega");
        } else {
          this.$notify({ type: "danger", message: "获取数据失败" });
        }
      });
      this.$refs.myvegaView3.vegaInit();
    },
    // 获取异步任务查询
    getApmTask(taskId, typename) {
      apiAxios.apmAsyncResult(taskId, {}, (_r) => {
        if (_r.data?.taskStatus == 1) {
          window.setTimeout(() => this.getApmTask(taskId, typename), 1000);
        } else if (_r.data?.taskStatus == 11 && _r?.data?.taskResponse) {
          this.isdebug = false;
          let _response = JSON.parse(_r.data.taskResponse);
          if (_response?.code == "200" && _response?.data?.result?.code != "500") {
            let _fileInfo = _response?.data?.result;
            if (typename == "updateVega") {
              if(_fileInfo.data){
              let _data = _fileInfo.data;
              this.$refs.myvegaView1.vegaInit(_data);
              this.$refs.myvegaView2.vegaInit(_data);
              }else if(_fileInfo.file){
                apiAxios.get(`${config.serverUrl}/basiceg/v1/csp/file/${_fileInfo.file}`,{},res2=>{
                  if(res2.code==200){
                    this.$refs.myvegaView1.vegaInit(res2.data);
                     this.$refs.myvegaView2.vegaInit(res2.data);
                  }
                 // console.log(res2)
                })
              }
            }
          } else {
            this.$notify({ type: "danger", message: "获取数据失败" });
          }
        } else {
          this.$notify({ type: "danger", message: "获取数据失败" });
        }
      });
    },
  },
  mounted() {
    this.vegaInit();
  },
  created() {
   // this.$store.dispatch("setSiteHeaderIconColor", "#fff");
  },
};
</script>

<style lang="less" scoped>
.site-header {
  .myicon {
    color: #fff;
  }
}

.data-view {
  // width: 100%;
  // height: 100%;
  // height: 100vh;
  // background-color: #030409;
  color: #fff;
  background-color: #000;

  .dv-full-screen-container {
    // background: url('~@/assets/img/bigScreen/bg.png') center center;
    // background-size: cover;
    -webkit-box-shadow: 0 0 3px #00f;
    box-shadow: 0 0 3px #00f;
    -ms-flex-direction: column;
    flex-direction: column;
    // position: fixed;
    // top: 0;
    // left: 0;
    // overflow: hidden;
    -webkit-transform-origin: left top;
    transform-origin: left top;
    // z-index: 999;

    .main-content {
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      flex-direction: row;
      flex: 1;
      flex-wrap: wrap;
    }
  }
}
</style>
